module.exports = "/_next/static/images/matt-holder-5189357a4bd2f560e762958c3de83aa5.jpg";